import FloatingActionButtons from "../floating/FloatingActionButtons";

const SidebarActions = () => {
  return (
    <>
      <div className="sidebar-actions-right fixed right-3 bottom-6 z-40 transition-all duration-300">
        <FloatingActionButtons location="right" />
      </div>
      <div className="sidebar-actions-left fixed left-3 bottom-6 z-40 transition-all duration-300">
        <FloatingActionButtons location="left" />
      </div>
    </>
  );
};

export default SidebarActions;